import { COLOR1, COLOR4 } from '../../constants';

export const topHeaderStyles = {
  top_header: {
    display: 'flex',
    opacity: 0.85,
    justifyContent: 'space-between',
    height: '66px',
    alignItems: 'center',
    '@media (max-width:650px)': {
      height: '65px',
      flexWrap: 'nowrap',
    },
  },

  leftHeaderSection: {
    display: 'flex',
    alignItems: 'center',
  },

  username_block: {
    font: 'normal normal normal 16px/18px Arial',
    letterSpacing: '0.11px',
    opacity: 1,
    marginRight: '52px',
    textTransform: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    gap: '8px',
    '@media (max-width:650px)': {
      margin: '0px 25px 0px 10px',
    },
    '@media (max-width:440px)': {
      margin: '0px 10px',
      font: 'normal normal normal 13px/16px Arial',
      textAlign: 'center',
      flexWrap: 'wrap-reverse',
    },
    '@media (max-width:340px)': {
      margin: '0px 5px',
      font: 'normal normal normal 10px/12px Arial',
    },
  },

  oriental: {
    display: 'block',
    width: '96px',
    height: '21px',
    marginLeft: '50px',
    borderRight: '1px solid #C5CEE0',
    paddingRight: '10px',
    marginRight: '5px',
    '@media (max-width:600px)': {
      marginLeft: '25px',
    },
  },

  profile_icon: {
    width: '26px',
    height: '26px',
    opacity: 1,
    '@media (max-width:370px)': {
      width: '25px',
      height: '25px',
    },
  },

  right_mobile_header: {
    '@media (max-width:650px)': {
      display: 'flex',
    },
  },
  lang_button: {
    position: 'absolute',
    right: '50px',
  },

  lang_change_button: {
    // font: 'normal normal normal 16px/18px Arial',
    letterSpacing: '0.11px',
    opacity: 1,
    // color: '#000000 !important',
    marginRight: '40px',
    '&.Mui-disabled span': {
      opacity: 1,
    },
    '&:focus': {
      border: '2px solid #000',
    },
    '@media (max-width:650px)': {
      marginRight: '0px',
      paddingY: '0',
    },
    '@media (max-width:420px)': {
      font: 'normal normal normal 13px/16px Arial',
    },
    '@media (max-width:370px)': {
      marginRight: '0px',
      font: 'normal normal normal 12px/16px Arial',
    },
  },

  language_icon: {
    width: '26px',
    height: '26px',
    opacity: 1,
    paddingRight: '6px',
    '@media (max-width:370px)': {
      width: '25px',
      height: '25px',
    },
  },

  orientalText: {
    marginLeft: '50px',
    '@media (max-width:600px)': {
      marginLeft: '28px',
    },
  },
  leftHeaderSectionBundle: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    '@media (max-width:600px)': {
      flexDirection: 'column-reverse',
      alignItems: 'flex-start',
      // width: 'fit-content',
    },
    '@media (max-width:400px)': {
      width: '100%',
    },
  },
  bundleMobileHeader: {
    display: 'flex',
    '@media (max-width:600px)': {
      position: 'absolute',
      right: '0px',
      top: '32px',
    },
  },
  orientalBundle: {
    display: 'block',
    width: '96px',
    height: '21px',
    marginLeft: '50px',
    paddingRight: '10px',
    marginRight: '5px',
    '@media (max-width:600px)': {
      marginLeft: '12px',
      borderRight: 'none',
      paddingTop: '8px',
      marginRight: 0,
    },
  },
  fdicsideBundle: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    '@media (max-width:600px)': {
      marginTop: '10px',
      width: '100%',
      marginLeft: '12px',
    },
    '@media (max-width:450px)': {
      width: '80%',
    },
  },
  right_mobile_header_bundle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',
    flexWrap: 'wrap',
    '@media (max-width:600px)': {
      // marginTop: '30px',
      // width: '100%',
      // position: 'absolute',
    },
  },

  orientalfdicBundle: {
    width: '100%',
    maxWidth: '393px',
    height: 'auto',
  },
  lang_change_button_bundle: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '14px',
    color: '#000',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
  },
};
